import { push } from 'react-router-redux';
import actions from '../constants';

export default () => dispatch => {
  dispatch({ type: actions.LOGOFF_FINISH });
  dispatch(push('/sign-in'));
};



// WEBPACK FOOTER //
// ./src/modules/auth/actions/finishLogoff.js